import func from "@uikit/func";
import { splitText } from "../views/thinking-layout-editor/util";
import { Api } from "../uikit/service/api";

export default function useShowStockInterfaceFunc({ postAIDescription, setNodeParam, setNodeErrorTip }) {
  const api = new Api(false);

  const handleStockInterfaceFunc = async (query, edgeParam) => {
    let formatRes = [];
    try {
      setNodeParam({
        id: edgeParam.target,
        data: {
          showStopGenerateBtn: true,
          stockLoading: true,
        },
      });
      const res = await postAIDescription(
        null,
        "brain_studios_xxx_brain_studios_extract_stock.model",
        { input: query },
        false,
        true,
        edgeParam
      );
      const stockSymbolStr = res
        .map(x => x.title)
        .filter(x => !func.isEmpty(x))
        .join("\n");
      // 切分
      const splitedArr = splitText(stockSymbolStr);
      const getStockSymbolArr = splitedArr.map(x => {
        return api.getWithErrorCanAbort(`/be/svc-adapter/stock/symbol?text=${x}`);
      });
      // 添加可取消
      setNodeParam({
        id: edgeParam.target,
        data: {
          abortNode: {
            source: edgeParam.source,
            target: edgeParam.target,
            edgeId: edgeParam.id,
            apiInstance: getStockSymbolArr,
          },
        },
      });
      // 调用stock api
      const stockRes = await Promise.allSettled(getStockSymbolArr);
      const fulfilledStockRes = stockRes.filter(x => x.status === "fulfilled").map(x => x.value.data.data);
      const isAbort = stockRes.filter(x => x.status === "rejected").some(x => x.reason.name === "AbortError");
      if (isAbort) {
        throw {
          fromApiError: "The user aborted a request.",
        };
      }
      // 重构返回的stock数据
      formatRes = fulfilledStockRes
        .filter(x => !func.isEmpty(x.name))
        .map(x => ({
          logo: x.logo,
          name: x.name,
          symbol: x.symbol,
          price: `$ ${x.price}`,
          volume: x.volume,
          businessSummary: x.business_summary,
        }));
    } catch (error) {
      if (func.isEmpty(error.fromApiError)) {
        const errText = typeof error === "string" ? error : error.message;
        error = {
          specifyErrorText: errText || "Get stock failed",
        };
      }
      setNodeErrorTip(edgeParam.target, error);
    } finally {
      setNodeParam({
        id: edgeParam.target,
        data: {
          showStopGenerateBtn: false,
          stockLoading: false,
          abortNode: {},
        },
      });
    }
    return {
      formatRes,
    };
  };

  return {
    handleStockInterfaceFunc,
  };
}
